import { useEffect, useState } from 'react'

import classNames from 'classnames'

import { Router, useRouter } from 'next/router'

import styles from './index.module.css'

interface Props {
  children: React.ReactNode
  [props: string]: any
}

const ShadowedHeader = ({ children, ...props }: Props) => {
  const { pathname, isReady } = useRouter()
  const [offset, setOffset] = useState(
    typeof window !== 'undefined' ? window.pageYOffset : 0
  )

  const isProfilePage = isReady ? pathname.includes('profile') : false

  useEffect(() => {
    const onScroll = () => setOffset(window.pageYOffset)

    window.addEventListener('scroll', onScroll)
    Router.events.on('routeChangeStart', onScroll)
    Router.events.on('routeChangeComplete', onScroll)
    Router.events.on('routeChangeError', onScroll)

    return () => {
      window.removeEventListener('scroll', onScroll)
      Router.events.off('routeChangeStart', onScroll)
      Router.events.off('routeChangeComplete', onScroll)
      Router.events.off('routeChangeError', onScroll)
    }
  }, [])

  return (
    <header
      {...props}
      className={classNames(props.className, styles.hasBanner, {
        [isProfilePage ? styles.withOffsetGray : styles.withOffset]:
          offset > 10,
      })}
    >
      {children}
    </header>
  )
}

export default ShadowedHeader
